import { useDisplay } from 'vuetify';

// Single source of truth for breakpoint checks across the app. Components
// should branch on these refs instead of ad-hoc @media queries so the mobile
// policy can evolve in one place.
export function useMobile() {
  const { xs, smAndDown, mdAndUp } = useDisplay();

  return {
    // < 600px: phones — fullscreen dialogs, native pickers, card lists
    isPhone: xs,
    // < 960px: phones + small tablets — collapsed nav, stacked filters
    isMobile: smAndDown,
    // >= 960px: desktop layout
    mdAndUp,
  };
}
